import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import SalesOrder from './SalesOrderDetail'
import { callNumber } from '../../../sipgate/state/action'


const mapStateToProps = (state, props) => {
    return {
        salesOrderId: props.computedMatch.params.salesOrderId,
        salesOrder: selector.selectSalesOrder(state),
        salutationList: Globals.selector.selectSalutationList(state),
        salesOrderStatusList: Globals.selector.selectSalesOrderStatusList(state),
        salesOrderTreatmentStatusList: Globals.selector.selectSalesOrderTreatmentStatusList(state),
        contact: selector.selectSalesOrderCustomerContact(state),
        error: selector.selectAPIError(state)
    }
}

const mapDispatchToProps = {
    findSalesOrder: action.findSalesOrder,
    changeSalesOrder: action.changeSalesOrder,
    saveSalesOrder: action.saveSalesOrder,
    changeSalesOrderCustomer: action.changeSalesOrderCustomer,
    saveSalesOrderCustomer: action.saveSalesOrderCustomer,
    addSentEmail: action.addSentEmail,
    addInvoice: action.addInvoice,
    addShipment: action.addShipment,
    callNumber: callNumber,
    changeCustomerContact: action.changeSalesOrderCustomerContact,
    saveCustomerContact: action.saveSalesOrderCustomerContact,
    hydrateContact: action.hydrateSalesOrderCustomerContact
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrder)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderDetailContainer.js